<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <base-input 
          v-uppercase 
          v-model="service.label" 
          label="Name" 
        />
        <base-input label="Select Service Category">
          <el-select 
            v-model="service.serviceCategoryId" 
          >
            <el-option
              v-for="(item, index) in serviceCategories"
              :key="index"
              :value="item.serviceCategoryId"
              :label="item.label"
            />
          </el-select>
        </base-input>
      </div>
    </div>
    <base-button 
      md 
      type="primary" 
      @click="onSubmit()">Save</base-button>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("service", ["service"]),
    ...mapGetters({
      serviceCategories: "serviceCategory/getServiceCategoryList",
    }),
  },

  mounted() {
    this.getServiceCategoryList();
  },

  methods: {
    ...mapActions({
      saveService: "service/saveService",
      getServiceList: "service/getServiceList",
      getServiceCategoryList: "serviceCategory/getServiceCategoryList",
      updateService: "service/updateService",
    }),

    onSubmit() {
      if (this.service.serviceId) {
        this.updateService().then((res) => {
          this.$notify({
            message: "Service Updated Succesfully!",
            type: "success",
            title: "Succes",
          });
          this.getServiceList();
          this.$emit("close");
        });
      } else {
        this.saveService().then((res) => {
          this.$notify({
            message: "Service Created Succesfully!",
            type: "success",
            title: "Success",
          });
          this.getServiceList();
          this.$emit("close");
        });
      }
    },
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
};
</script>